import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import './AppointmentScheduler.scss';
import './Animations.scss';

import AppointmentForm from './AppointmentForm/AppointmentForm';
import BusyIndicator from '../BusyIndicator/BusyIndicator';

import Api from '../Api';
import Validator from './Validator';
import Screen from '../Helpers/Screen';

import { STEPS } from './constants';

export default class AppointmentScheduler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: null,
            currentStep: STEPS.GENERAL_DETAILS,
            appointment: { campaignId: props.campaignId },
            generalErrors: {},
            personalErrors: {},
            isBusy: true,
            mouseOver: false,
            data: {
                centers: [],
                scheduleTimes: [],
                serviceTypes: [],
                cars: [],

            }
        };
        this.barToggle = this.barToggle.bind(this);
        this.moveNext = this.moveNext.bind(this);
        this.setAppointmentState = this.setAppointmentState.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
        this.onGeneralTitleClick = this.onGeneralTitleClick.bind(this);
        this.onScrollHandler = this.onScrollHandler.bind(this);
    }

    componentDidMount() {
        Api.getAppointmentData().then((res) => {
            this.setState({
                data: res,
                isBusy: false
            });
        });

        this.bindOpenTriggers();
    }

    get TRIGGER_CLASS() {
        return 'js-schedule-appointment';
    }

    bindOpenTriggers() {
        [...document.getElementsByClassName(this.TRIGGER_CLASS)]
            .map((elem) => {
                elem.addEventListener('click', () => {
                    this.show();
                })
            });
    }

    onGeneralTitleClick() {
        if (this.state.currentStep === STEPS.PERSONAL_DETAILS) {
            this.setState({
                currentStep: STEPS.GENERAL_DETAILS
            });
        }
    }

    render() {
        let viewData = this.state.data;

        let view = null;

        if (this.state.isBusy) {
            view = <BusyIndicator />;
        } else if (this.isFormActive) {

            view = (<AppointmentForm
                data={this.state.data}
                scheduleDate={this.state.appointment.date}
                setAppointmentState={this.setAppointmentState}
                moveNext={this.moveNext}
                generalErrors={this.state.generalErrors}
                personalErrors={this.state.personalErrors}
                currentStep={this.state.currentStep}
                appointment={this.state.appointment}
                onGeneralTitleClick={this.onGeneralTitleClick}
            />);
        } else {
            if (this.state.currentStep === STEPS.THANK_YOU) {
                view = <ThankYouScreen onProceed={this.hide} />
            }
            if (this.state.currentStep === STEPS.ERROR) {
                view = <ErrorScreen onProceed={this.hide} />
            }
        }

        return (
            <div  className={`appointment-scheduler ${this.expandedClass}`}>
                        
                <div className="b-content">
                    <header className="b-header">
                        Appointment Scheduling
                        <a className="visible-xs" onClick={this.barToggle}><img src="/images/shared/header/xs-menu-close.svg" alt="xs-menu-close" /></a>
                    </header>

                    {view}
                </div>
            </div>
        );
    }

    get isFormActive() {
        return this.state.currentStep === STEPS.GENERAL_DETAILS ||
            this.state.currentStep === STEPS.PERSONAL_DETAILS
    }

    get expandedClass() {
        if (this.state.isExpanded === null) return '';

        return this.state.isExpanded ? 'expanded' : 'collapsed';
    }

    barToggle() {
        this.state.isExpanded ? this.hide() : this.show();
    }

    show(args) {
        this.setState({
            isExpanded: true
        });

        if (args && args.dealerId) {
            this.state.appointment.center = +args.dealerId;

            this.setState({
                appointment: this.state.appointment
            });
        }

        if (!Screen.isMobile) {
            document.addEventListener('scroll', this.onScrollHandler);
        }
    }

    onScrollHandler() {
      
    }

    hide() {
        this.setState({
            isExpanded: false
        });

        document.removeEventListener('scroll', this.onScrollHandler);
    }

    setAppointmentState(e) {
        var field = e.target.name;
        var value = e.target.value;
        this.state.appointment[field] = value;

        // for now reseting errors for both steps for current name
        // as a quick solution

        delete this.state.generalErrors[field];
        delete this.state.personalErrors[field];

        return this.setState({
            appointment: this.state.appointment,
            generalErrors: this.state.generalErrors,
            personalErrors: this.state.personalErrors
        });
    }

    isGeneralValid() {
        let isValid = false;
        this.state.generalErrors = {};
        let form = this.state.appointment;

        if (!form.center) {
            this.state.generalErrors['center'] = 'Please choose a center!';
        }

        if (!form.hours) {
            this.state.generalErrors['hours'] = 'Please choose available hours!';
        }

        if (!form.serviceType) {
            this.state.generalErrors['serviceType'] = 'Please choose service type!';
        }

        if (!form.make) {
            this.state.generalErrors['make'] = 'Please choose a car make!';
        }

        //if (!form.carModel) {
        //    this.state.generalErrors['carModel'] = 'Please choose a car model!';
        //}

        if (!Validator.carYear(form.CarYear)) {
            this.state.generalErrors['carYear'] = 'Please specify a valid car year';
        }

        this.setState({
            generalErrors: this.state.generalErrors
        });

        if (!Object.keys(this.state.generalErrors).length) {
            isValid = true;
        }

        return isValid;
    }

    moveNext() {
        if (this.state.currentStep === STEPS.GENERAL_DETAILS &&
            this.isGeneralValid()) {
            this.setState({
                currentStep: STEPS.PERSONAL_DETAILS
            });
        } else if (this.state.currentStep === STEPS.PERSONAL_DETAILS) {
            this.submitRequest();
        }
    }

    isPersonalValid() {
        let isValid = false;
        this.state.personalErrors = {};
        let appointment = this.state.appointment;

        if (!Validator.name(appointment.name)) {
            this.state.personalErrors['name'] = 'Please enter a valid name!';
        }

        if (!Validator.email(appointment.email)) {
            this.state.personalErrors['email'] = 'Please enter a valid email!';
        }

        if (!Validator.phone(appointment.phone)) {
            this.state.personalErrors['phone'] = 'Please enter a valid phone number!';
        }

        if (!Validator.comments(appointment.comment)) {
            this.state.personalErrors['comment'] = 'Comment exceeded max length';
        }
        if (!(appointment.captcha && appointment.captcha.getValue())) {
            this.state.personalErrors['captcha'] = 'Please check the captcha';
        }

        this.setState({
            personalErrors: this.state.personalErrors
        });

        if (!Object.keys(this.state.personalErrors).length) isValid = true;

        return isValid;
    }

    submitRequest() {
        if (this.isPersonalValid()) {
            this.state.appointment.captcha = undefined;
            if (!this.state.appointment.date) {
                this.state.appointment.date = new Date();
            }
            let response = Api.submitAppointment(this.state.appointment)
                .then((res) => {
                    let nextStep = res.ok ? STEPS.THANK_YOU : STEPS.ERROR;

                    this.setState({
                        currentStep: nextStep
                    });
                });
        }
    }
}

function ThankYouScreen(props) {
    return (<div className="thank-you-wrapper centered-section">
        <h3 className="step-title">
            Thank you
            </h3>
        For scheduling an appointment,
            <br />
        see you soon!

            <HomeBtnMobile onClick={props.onProceed} />
    </div>);
}

function ErrorScreen(props) {
    return (<div className="error-wrapper centered-section">
        <h3 className="step-title error">
            Error
            </h3>
        Please contact support for the
            <br />
        following email ...

            <HomeBtnMobile onClick={props.onProceed} />
    </div>);
}

function HomeBtnMobile(props) {
    return (
        <button className="apply-btn visible-xs"
            onClick={props.onClick}>
            Go to homepage
        </button>);
}

export let SchedulerInstance = null;

// used for direct component access from outside
let refCallback = (ref) => {
    SchedulerInstance = ref;
}

ReactDOM.render(<AppointmentScheduler ref={refCallback} campaignId={document.getElementById('app-bar-wrapper').getAttribute("campaignId")} />, document.getElementById('app-bar-wrapper'));


// WEBPACK FOOTER //
// ./Src/Shared/AppointmentScheduler/AppointmentScheduler.jsx